const router = [
  {
    path: '/workflow',
    name: 'workflow',
    redirect: '/workflow/list',
    component: () => import('@/modules/Workflow/pages'),
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import('@/modules/Workflow/pages/Workflow'),
        meta: {
          requiresAuth: true,
          requiresPermission: true,
          action: 7
        }
      },
      {
        path: 'create',
        name: 'workflowCreate',
        component: () => import('@/modules/Workflow/pages/WorkflowCreate'),
        meta: {
          requiresAuth: true,
          requiresPermission: true,
          action: 7
        }
      },
    ],
    meta: {
      requiresAuth: true,
      requiresPermission: true,
      action: 7
    }
  }
]
export default router